// import { useTranslations } from 'next-intl';

import Modal from "../../../../common/Modal";

import "./styles/index.css";

export const getStatusColor = (status) => {
  if (status >= 200 && status < 300) {
    return "status-success";
  } else if (status >= 400 && status < 500) {
    return "status-error";
  } else if (status >= 500) {
    return "status-fail";
  } else {
    return "";
  }
};

const parseResponseError = (responseError) => {
  try {
    return JSON.stringify(JSON.parse(responseError), null, 2);
  } catch (error) {
    console.log("Failed to parse response error:", { error, responseError });
    return responseError;
  }
}

const ApiRequestInfoModal = ({ onCloseClick, apiRequest }) => {
  const {
    id,
    requestMethod,
    requestedEndpoint,
    responseStatus,
    responseError,
    createdAt,
    originIP,
    apiKey,
  } = apiRequest;

  return (
    <Modal
      open={true}
      setOpen={onCloseClick}
      closeOnOutsideClick={true}
      className="api-request-info-modal"
    >
      <div
        className="container"
        onClick={() => {}} // prevent closing modal on click inside
      >
        <div className="info-container">
          <h4>{id}</h4>

          <h3>{requestMethod}</h3>
          <p>Endpoint: {requestedEndpoint}</p>
          <p>
            {"Response Status: "}
            <b className={getStatusColor(responseStatus)}>{responseStatus}</b>
          </p>
          {apiRequest.responseError && 
            <>
              <p>Response Error:</p>
              <pre id="error-box">{parseResponseError(responseError)}</pre>
            </>
          }

          <p>Date: {(new Date(createdAt)).toLocaleString()}</p>
          <p>IP: {originIP}</p>
          <p>API Key: {apiKey}</p>
        </div>

        <div className="buttons-container">
          <button
            className="primary btn btn--small"
            onClick={onCloseClick}
          >
            {'Close'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ApiRequestInfoModal;